import { transformDateValue } from 'core/js/FormUtils';
export const getProductrawtorawdemandView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let productrawtorawdemandList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          productrawtorawdemandList.push(card);
  })
  return productrawtorawdemandList;
}